import Component from "gia/Component";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.form = this.DOM.view.querySelector("form");
    this.DOM.select = this.DOM.view.querySelector("select");
    this.DOM.select.addEventListener("change", () => {
      this.ref.input[0].value = this.DOM.select.value;
      this.DOM.form.submit();
    });

  }

  unmount() {}
}
